import { z } from "zod";

export const ExchangeRateSummarySchema = z.object({
  avgRate1h: z.number().nullable(),
  avgRate8h: z.number().nullable(),
  avgRate24h: z.number().nullable(),
  stddevRate1h: z.number().nullable(),
  stddevRate8h: z.number().nullable(),
  stddevRate24h: z.number().nullable(),
  last1h: z.number().nullable(),
  updatedAt: z.string(),
});

export type ExchangeRateSummary = z.infer<typeof ExchangeRateSummarySchema>;

export const FundingRateSummaryItemSchema = z.object({
  symbol: z.string(),
  exchanges: z.record(z.string(), ExchangeRateSummarySchema),
});

export type FundingRateSummaryItem = z.infer<typeof FundingRateSummaryItemSchema>;

export const PaginatedFundingRateSummariesSchema = z.object({
  items: z.array(FundingRateSummaryItemSchema),
  supportedExchangeIds: z.array(z.string()),
  pagination: z.object({
    page: z.number(),
    limit: z.number(),
    total: z.number(),
  }),
});

export type PaginatedFundingRateSummaries = z.infer<typeof PaginatedFundingRateSummariesSchema>;
